import React from "react";
import { FaPrint, FaSearch } from "react-icons/fa";
import { GiReturnArrow } from "react-icons/gi";
import { formatRupiah } from "../../../../../helper/formatNumber";

import "./salesData.css";
import { formatDateTransactionDetail } from "../../../../../helper/formatDate";

const SalesData = ({
  transactionDate,
  transactionData,
  onPrintTransaction,
  onOpenDetailTransaction,
  onOpenRefundTransaction,
}) => {
  const getBackgroundColor = (paymentMethod) => {
    switch (paymentMethod) {
      case "CASH":
        return "#F0F0F0";
      case "TRANSFER":
        return "#FFF9C4";
      case "DEBIT":
        return "#C8E6C9";
      case "QRIS":
        return "#FFE0B2";
      case "KARTU KREDIT":
        return "#BBDEFB";
      case "REKANAN":
        return "#D1C4E9";
      case "ONLINE":
        return "#f56969ff";
      default:
        break;
    }
  };
  const userData = JSON.parse(localStorage.getItem("user_data"));

  return (
    <div className="sales-data-container">
      <h4>Transaksi pada {transactionDate}</h4>
      <div className="sales-data-table-container">
        {transactionData.map((data, index) => (
          <div
            className="sales-data-row"
            key={data.product_transaction_invoice_number}
          >
            <p
              className="sales-data-column"
              style={{
                backgroundColor: getBackgroundColor(data.payment_method),
              }}
            >
              {data.product_transaction_invoice_number}
            </p>
            <p className="sales-data-column">
              {formatDateTransactionDetail(data.product_transaction_date)}
            </p>
            <p className="sales-data-column">
              <b>{formatRupiah(data.total_transaction)}</b>
            </p>
            {data.patient_name === "" ? (
              <p className="sales-data-column">-</p>
            ) : (
              <p className="sales-data-column">{data.patient_name}</p>
            )}
            {data.doctor_name === "" ? (
              <p className="sales-data-column">-</p>
            ) : (
              <p className="sales-data-column">{data.doctor_name}</p>
            )}
            <p className="sales-data-column">{data.staff_name}</p>
            <p className="sales-data-column">
              {data.staff_shift === 0 ? "Pagi" : "Siang"}
            </p>
            <div className="sales-data-actions">
              {typeof onPrintTransaction === "function" && (
                <button
                  className="sales-data-action-button"
                  onClick={() => onPrintTransaction(data)}
                >
                  <FaPrint />
                </button>
              )}
              <button
                className="sales-data-action-button"
                onClick={() => onOpenDetailTransaction(data)}
              >
                <FaSearch />
              </button>
              {typeof onOpenRefundTransaction === "function" &&
                userData &&
                ["ADMIN", "MANAGER"].includes(
                  userData.staff_system_role
                ) && (
                  <button
                    className="sales-data-action-button"
                    onClick={() =>
                      onOpenRefundTransaction(data.product_transaction_id)
                    }
                  >
                    <GiReturnArrow />
                  </button>
                )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SalesData;
